<template>
  <div style="height: 100%;overflow-y: auto;padding:10px">
    <!-- 保检登记 -->
    <enrollment :title="$t('maintenance.BX')" :size="size" :showExport="true" @handleQuery="handleQuery" @add="add" @export="onExportClick"></enrollment>
    <!-- 车辆列表 -->
    <div class="page_container_a">
      <el-table :data="dataList" border :size="size" highlight-current-row v-loading="loading">
        <el-table-column :label="$t('maintenance.order')" align="center" type="index" min-width="90"></el-table-column>
        <el-table-column :label="$t('vehicle.carNo')" align="center" prop="carNo"></el-table-column>
        <el-table-column :label="$t('time.startTimeHolder')" align="center" prop="beginInsureTime"></el-table-column>
        <el-table-column :label="$t('time.endTimeHolder')" align="center" prop="nextInsureTime"></el-table-column>
        <el-table-column :label="$t('maintenance.OPTName')" align="center" prop="OPTName"></el-table-column>
        <el-table-column :label="$t('public.Operation')" align="center" min-width="150" fixed="right">
          <template slot-scope="scope">
            <el-link :underline="false" style="margin-right:20px" @click="edit(scope.row)">
              <i class="iconfont icon-icon_operat_edite" style="height: 16px;width:16px"></i> {{ $t("public.edit") }}
            </el-link>
            <el-link :underline="false" @click="del(scope.row)"><i class="iconfont icon-icon_operat_delete"
                style="height: 16px;width:16px"></i> {{ $t("public.del") }}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <kl-pagination :total="total" :currentPage="currentPage" @current-change="currentchange" @size-change="sizeChange"></kl-pagination>
    <!-- 弹窗 -->
    <el-dialog class="dialog" :title="title" :visible.sync="dialogVisible" width="440px" :close-on-click-modal="false">
      <div style="text-align:left;">
        <el-form ref="form" :model="form" :rules="rules1" label-width="110px"
          :label-position="LanguageId == 1 ? 'right' : 'top'">
          <el-form-item :label="$t('vehicle.carNo') + '：'" label-position="right" filterable prop="selCarNo">
            <el-select v-model="form.selCarNo" placeholder="" :size="size"
              :style="{ 'width': LanguageId == 1 ? '250px' : '100%' }" :disabled="BXFlag == 1">
              <el-option v-for="item in vehiclesOption" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('maintenance.entryTime') + '：'" label-position="right" prop="entryTime">
            <el-date-picker v-model="form.entryTime" placeholder="" :size="size"
              :style="{ 'width': LanguageId == 1 ? '250px' : '100%' }" :clearable="false"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('maintenance.OPTName') + '：'" label-position="right" filterable>
            <el-input v-model="form.entryMan" :style="{ 'width': LanguageId == 1 ? '250px' : '100%' }"
              :size="size"></el-input>
          </el-form-item>
          <el-form-item :label="$t('maintenance.BXDaterange')" label-position="right" prop="daterange">
            <el-date-picker :size="size" :style="{ 'width': LanguageId == 1 ? '250px' : '100%' }" v-model="form.daterange"
              type="daterange" :range-separator="$t('time.to')" :start-placeholder="$t('time.startDate')"
              :end-placeholder="$t('time.endDate')" :clearable="false">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
        <el-button type="primary" @click="submitSave">{{ $t("public.save") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import KLLabel from '@/components/KLLabel.vue'
import Enrollment from '../components/enrollment.vue'
import { mapState } from "vuex";
import language from '@/utils/getLanguageId'
import * as XLSX from 'xlsx'
export default {
    name: "insurancerecord",
  data() {
    var validateDate = (rule, value, callback) => {
      // console.log(value);
      if (value === "") {
        callback(new Error(this.$t('maintenance.Select_time_range')));
      } else if (value == null || value == undefined) {
        callback(new Error(this.$t('maintenance.Select_time_range')));
      } else if (value.length == 0) {
        callback(new Error(this.$t('maintenance.Select_time_range')));
      } else {
        callback();
      }
    };
    return {
      rules1: {
        selCarNo: [
          { required: true, message: this.$t('maintenancemanagement.selectvehicle'), trigger: 'change' }
        ],
        entryTime: [
          { required: true, message: this.$t('vehicleInfo.selectusedate'), trigger: 'change' }
        ],
        daterange: [
          { required: true, validator: validateDate, trigger: "change" },
        ]
      },
      currentPage: 1,
      total: 0,
      BXFlag: 0,
      form: {
        entryTime: "",
        selCarNo: "",
        entryMan: "",
        daterange: [],
      },
      dialogVisible: false,
      total: 0,
      dataList: [],
      inputCarNo: "",
      vehiclesOption: [],
      inputCarNo: "",
      VehicleID: undefined,
      nextInsureTimeTemp: undefined,
      loading: false,
      LanguageId: 1,
      pageSize:10,
    }
  },
  props: {},
  components: { Enrollment, KLLabel },
  computed: {
    size() {
      return this.$store.getters.size
    },
    title() {
      if (this.BXFlag == 1) return this.$t("maintenance.BXEdit");
      else return this.$t("maintenance.BX");
    },
    ...mapState({
      operator: (state) => state.user.operator,
      appVehicles: state => state.app.vehicles,
    }),
  },
  methods: {
    sizeChange(val){
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    currentchange(page) {
      this.currentPage = page;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$api.insuranceInfo({
        vehicle: this.inputCarNo,
        CompanyID: this.operator.CompanyId,
        PageNo: this.currentPage,
        PageSize: this.pageSize,
        OperatorID: this.operator.OperatorId
      })
        .then((res) => {
          if (res && res.code == 200) {
            this.dataList = res.data;
            this.total = res.count;
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          this.dataList = [];
          this.total = 0;
        })
    },
    submitSave() {
      let VID = '';
      VID = this.BXFlag == 1 ? this.VehicleID : this.form.selCarNo;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if ((this.form.daterange == null || this.form.daterange == undefined || this.form.daterange.length == 0)) {
            // this.$message.info("请填写保险期限");
            return;
          }
          this.$api.insuranceSave({
            BXFlag: this.BXFlag,
            VehicleID: VID,
            entryTime: this.moment(this.form.entryTime).format("YYYY-MM-DD"),
            OperatorID: this.operator.OperatorId,
            beginInsureTime: this.moment(this.form.daterange[0]).format("YYYY-MM-DD"),
            nextInsureTime: this.moment(this.form.daterange[1]).format("YYYY-MM-DD"),
            nextInsureTimeTemp: this.BXFlag == 0 ? "" : this.nextInsureTimeTemp,
          })
            .then((res) => {
              if (res.code == 200) {
                this.dialogVisible = false;
                this.$message.success(this.$t("public.hasSaved"));
                this.getList();
              }

            })
            .catch((e) => {
              this.dialogVisible = false;
              console.log(e.response.data.message);
              let errorInfo = "";
              if (e.response.data.message === "查询到之前设置过保险记录") errorInfo = "，" + this.$t("maintenance.RecordsAlreadyExist");
              this.$message.error(this.$t("public.SaveFail") + errorInfo);
            })

        } else {
        }
      });

    },
    handleQuery(val) {
      // console.log(val);
      this.inputCarNo = val;
      this.currentPage = 1;
      this.getList();
    },
    onExportClick() {
      // 导出全部：PageNo=1, PageSize=65535
      this.loading = true;
      this.$api.insuranceInfo({
        vehicle: this.inputCarNo,
        CompanyID: this.operator.CompanyId,
        PageNo: 1,
        PageSize: 65535,
        OperatorID: this.operator.OperatorId
      }).then((res) => {
        this.loading = false;
        if (!res || res.code != 200 || !res.data || res.data.length === 0) {
          this.$message.warning(this.$t('maintenance.no_data_export'));
          return;
        }
        this.exportToExcel(res.data);
        this.$message.success(this.$t('maintenance.export_success'));
      }).catch(() => {
        this.loading = false;
      });
    },
    exportToExcel(list) {
      const header = [
        this.$t('vehicle.carNo'),
        this.$t('time.startTimeHolder'),
        this.$t('time.endTimeHolder'),
        this.$t('maintenance.OPTName')
      ];
      const rows = list.map(item => [
        item.carNo || '',
        item.beginInsureTime || '',
        item.nextInsureTime || '',
        item.OPTName || ''
      ]);
      const aoa = [header, ...rows];
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, this.$t('maintenance.BX'));
      const fileName = this.$t('maintenance.BX') +
        this.moment(new Date()).format('YYYY-MM-DD') + '.xlsx';
      XLSX.writeFile(wb, fileName);
    },
    add() {
      this.dialogVisible = true;

      this.resetForm("form");
      this.BXFlag = 0;

    },
    edit(row) {
      this.dialogVisible = true;
      this.VehicleID = row.VehicleID;
      this.nextInsureTimeTemp = row.nextInsureTime;
      this.form = {
        entryTime: row.entryTime,
        selCarNo: row.carNo,
        entryMan: row.OPTName ? row.OPTName : " ",
        daterange: [row.beginInsureTime, row.nextInsureTime],
      }
      this.BXFlag = 1;
    },
    del(row) {
      this.$confirm(
        this.$t("maintenance.confirmDelete"),
        "",
        {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.insuranceDel({
            VehicleID: row.VehicleID,
            nextInsureTime: row.nextInsureTime
          })
            .then((res) => {
              if (res && res.code == 200) {
                this.getList();
                this.$message.success(this.$t("public.hasDeleted"));
              }
            })
            .catch((e) => {
              this.$message.success(this.$t("public.DeleteFail"));
            })
        })
        .catch(() => { });
    },
    resetForm(refName) {
      this.form = {
        entryTime: new Date(),
        selCarNo: "",
        entryMan: this.operator.OpeName,
        daterange: [],
      }
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    }
  },
  mounted() {
    this.LanguageId = language(this.$store.getters.locale)
    this.form.entryMan = this.operator.OpeName;
    setTimeout(() => {
      let appVeh = JSON.parse(JSON.stringify(this.appVehicles)).data;
      appVeh.forEach(element => {
        if (element.treeLevel == 5) {
          this.vehiclesOption.push({
            value: element.nodeValue,
            label: element.vehicleName,
          })
        }
      });
    }, 50);
    this.getList();
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #EBEEF5 !important;
  }

}

 

.page_container_a {
  margin-top: 10px;

  ::v-deep .el-table tr {
    background: rgb(244, 248, 255);
  }

  ::v-deep .el-table {
    background: rgb(244, 248, 255);
  }

  ::v-deep .el-table td {
    background: rgb(244, 248, 255);
  }
}
</style>